(() => {
  const selector = '.price, .price-per-item--current, .variant-item__old-price';
  const encodedMoney = /<span\s+class=["']?trans-money["']?\s*>(.*?)<\/span>/gi;

  function cleanPrice(element) {
    if (!element || !element.textContent || !element.textContent.includes('trans-money')) return;
    const cleaned = element.textContent.replace(encodedMoney, '$1');
    if (cleaned !== element.textContent) element.textContent = cleaned;
  }

  function cleanWithin(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches?.(selector)) cleanPrice(root);
    root.querySelectorAll?.(selector).forEach(cleanPrice);
  }

  function start() {
    cleanWithin(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          cleanPrice(mutation.target.parentElement?.closest(selector));
        } else {
          mutation.addedNodes.forEach(cleanWithin);
          cleanPrice(mutation.target.closest?.(selector));
        }
      });
    }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
